import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-4',
    title: 'heading-xl md:heading-m-bold',
    products: 'flex flex-col gap-4'
  }
});
